import Kanyi from "./images/kanyi_mwangi.jpg";
import Rita from "./images/rita_njeri.jpg";
import Devesa from "./images/devesa_neto.jpg";
import Rochelle from "./images/rochelle_halim.jpg";
import Lara from "./images/lara_randle.jpg";
import Salma from "./images/salma_ettamen.jpg";
import All from "./images/all.png";

const Intro = ({ breakPoints }) => {
  return (
    <div className={`flex justify-center items-center ${breakPoints} py-10 mb-32`}>
      {/* Updated this div for responsive grid layout */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-24 relative">
        {/* First column now taking 1/3 of the space on medium devices and up */}
        <div className="md:col-span-2 text-black flex flex-col justify-between">
          <div className="text-xl md:text-2xl text-left font-montserrat font-bold">
            Leadership takes on new meaning when shaped by the unique
            resilience, creativity, and vision of women.
          </div>
          <div className="w-full object-fit py-4">
            <img src={All} alt="All" className="w-full object-fit" />
          </div>
        
        {/* New image grid 
          
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-8 mb-4">
        <img
          src={Kanyi}
          alt="Kanyi Mwangi"
          className="w-full h-56 md:h-32 object-cover"
        />
        <img 
          src={Rita} 
          alt="Rita Njeri" 
          className="w-full h-56 md:h-32 object-cover" 
        />
        <img
          src={Devesa}
          alt="Devesa Neto"
          className="w-full h-56 md:h-32 object-cover"
        />
        <img
          src={Rochelle}
          alt="Rochelle Halim"
          className="w-full h-56 md:h-32 object-cover"
        />
        <img
          src={Lara}
          alt="Lara Randle"
          className="w-full h-56 md:h-32 object-cover"
        />
        <img
          src={Salma}
          alt="Salma Ettamen"
          className="w-full h-56 md:h-32 object-cover"
        />
      </div>
      */}
      <div className="text-sm md:text-md text-left font-poppins">
            At Mastercard, these qualities are celebrated and championed through the She is Priceless campaign, which highlights the extraordinary
            contributions women make—not only as leaders but as catalysts for meaningful change. From redefining workplace culture to driving
            innovation, Mastercard's women leaders embody the values of empathy, adaptability, and progress.        </div>
        </div>

        {/* Vertical Divider - only visible on md and up */}
        <div className="hidden md:block absolute h-full w-0.5 bg-mcGray2" style={{ left: '40%' }}></div>

        {/* Second column now taking 2/3 of the space on medium devices and up */}
        <div className="md:col-span-3 text-black flex flex-col justify-between">
          <div className="text-sm md:text-md text-left font-poppins">
            <p className="mb-4">
            Women in Africa score just 50.3% in equality across economic, social, and public representation areas, according to a 2023 report,
            which is a slight improvement from the 48% score in 2019. Specifically in tech, women make up just 30% of the tech workforce
            highlighting the pressing need for change on a continent that is positioned for massive growth in technology. 
            </p>
            <p className="mb-4">
            At Mastercard, diversity, equity, and inclusion (DEI) are integral to who we are. Embracing different perspectives not only strengthens us but also
            drives meaningful connections and innovative solutions. It is through this commitment that we strive to create lasting,
            sustainable change in our industry and in communities that have been, historically, underserved. 
            </p>
            <p className="mb-4">
            Mastercard is leading the charge with initiatives like Girls4Tech, which has reached over 5.7 million girls globally, equipping them with STEM skills. Additionally, its
            support for women-owned businesses and equitable hiring practices reflects its commitment to fostering inclusivity and innovation. 
            </p>
            <p className="mb-4">
            For Mastercard, 'she' is the driving force behind a digitized, inclusive economy. Now in its second year, She is Priceless has become more
            than a campaign— it's a commitment to balance, progress, and prosperity for all. By amplifying the voices of exceptional women,
            Mastercard creates role models for the next generation and builds a culture where women are not just participants but pivotal leaders.
            </p>
          </div>
          <div className="text-xl md:text-2xl text-left font-montserrat font-bold text-mcOrange">
            This is leadership redefined. This is Mastercard's vision for the
            future, with women leading the way.
          </div>
        </div>
      </div>

   
    </div>
  );
};

export default Intro;
